import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { DataRerunsReducerType } from 'redux/reducers/internal/DataReruns'
import { EReduxState } from 'redux/utils/State'

import type { TDataRerunDetailDto } from '@homepal/api-contract'

export const selectInternalDataReruns = createSelector(
  [
    (state: ApplicationState): DataRerunsReducerType =>
      state.InternalDataRerunsStore
  ],
  (store) => store
)

export const selectReruns = (state: ApplicationState) =>
  state.InternalDataRerunsStore.reruns

export const selectRerunsFetchStatus = (state: ApplicationState) =>
  state.InternalDataRerunsStore.rerunsFetchStatus

export const selectActiveReruns = (state: ApplicationState) =>
  state.InternalDataRerunsStore.activeReruns

export const selectActiveRerunsFetchStatus = (state: ApplicationState) =>
  state.InternalDataRerunsStore.activeRerunsFetchStatus

/** The fetched detail of rerun `id`, null while another one is stored. */
export const selectRerun = (
  state: ApplicationState,
  id: string | null
): TDataRerunDetailDto | null => {
  const { selectedRerun } = state.InternalDataRerunsStore

  return id && selectedRerun?.id === id ? selectedRerun : null
}

/** Status of the detail request for `id`, IDLE until one is made. */
export const selectRerunFetchStatus = (
  state: ApplicationState,
  id: string | null
): EReduxState => {
  const { requestedRerunId, selectedRerunFetchStatus } =
    state.InternalDataRerunsStore

  return id && requestedRerunId === id
    ? selectedRerunFetchStatus
    : EReduxState.IDLE
}

export type {
  TDataRerunCustomerDto as DataRerunCustomer,
  TDataRerunDetailDto as DataRerunDetail,
  TDataRerunSummaryDto as DataRerunSummary,
  TRerunCandidateDto as RerunCandidate,
  TRerunJobRefDto as RerunJobRef
} from '@homepal/api-contract'
